import { httpGetServiceProfiles } from 'app/api/commerce';
import { ServiceProfile } from 'app/utilities/types/shared';
import { useCallback, useState } from 'react';

export interface Restaurant {
  id: string;
  name: string;
  dateAdded: string;
}

export const useGetServiceProfiles = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<ServiceProfile[]>([]);

  const fetchServiceProfiles = useCallback(
    async ({
      userId,
      roleId,
      outletType,
    }: {
      userId: string;
      roleId: string;
      outletType: string;
    }) => {
      try {
        const response = await httpGetServiceProfiles({
          userId,
          roleId,
          outletType,
        });
        setData(response);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    },
    []
  );

  return { fetchServiceProfiles, isLoading, data };
};
